import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { HydraErrorType } from '../_hydraError'
import type { HydraLines } from '../account/GET/getSubscriptions'
import type { HydraAddress } from '../account/GET/getOrderDetails'

export type HydraShipByEstimationResponse = {
  shipBy: string
}

export type HydraShipByEstimationProps = {
  hydraToken: string
  lines: Partial<HydraLines>
  shipToAddress: HydraAddress
}

export const HydraShipByEstimation = ({
  hydraToken,
  lines,
  shipToAddress,
}: HydraShipByEstimationProps) => {
  const request: SendRequestType = {
    method: 'POST',
    url: `/shipby`,
    withAuth: true,
    token: hydraToken,
    data: {
      order: {
        market: shipToAddress.country,
        lines,
        shipToAddress: {
          address: shipToAddress.address1,
          city: shipToAddress.city,
          country: shipToAddress.country,
          state: shipToAddress.state,
          zip: shipToAddress.zip,
        },
      },
    },
  }
  return httpTools.sendRequest<HydraShipByEstimationResponse & HydraErrorType>(
    request,
  )
}
